import type { ModuleDependency } from '@/schemas/commons';

// The backend's LLM probe runs a real 1-token canary call and reports credit
// exhaustion as a `down` verdict whose message embeds this marker (see
// `shared/health/probes.py` in bizops-ai-agents-back). Matching on the marker
// instead of the exact string keeps the UI tolerant to wording tweaks.
const CREDIT_MARKER = 'credit balance';

export const findCreditExhaustion = <T extends ModuleDependency>(dependencies: T[]): T | null =>
	dependencies.find(
		(dep) => dep.kind === 'llm' && dep.status === 'down' && (dep.message ?? '').toLowerCase().includes(CREDIT_MARKER),
	) ?? null;
